// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2k9Ea","list":"styles_list__2lJ-V"};